import React from 'react';
import FlowRendererField from 'conversie-flow-bundle/assets/js/components/flow/renderers/FlowRendererField';

/* Utilities */
import { trans } from 'js/utilities';

export default function ConversionFlowComponentPurchaseTypeConfigurator({ component, uspsLease, path, id, ...passProps }) {
    const PriceFormat = Intl.NumberFormat(
        'nl-NL',
        {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }
    );

    const purchaseTypeField = component?.fields?.find(field => field.name === 'purchase_type');
    const selectedPurchaseType = Array.isArray(purchaseTypeField?.value) ? purchaseTypeField.value[0] : purchaseTypeField?.value || '';

    const renderPriceDisplay = () => {
        if (!selectedPurchaseType) return null;

        switch (selectedPurchaseType) {
            case 'Financial lease':
            case 'Operational lease':
            case 'Shortlease':
                if (component.metadata?.price_per_month) {
                    return (
                        <div className="col-12">
                            <div className="price-per-month">
                                <p className="text--14 text--xl-16 mb-0">
                                    {trans('flow.finance.price_per_month')}
                                </p>
                                <p className="mb-1 text-right text-md-left text-base text--22 font-weight-extra-bold">
                                    {component.metadata.price_per_month === 'Op aanvraag' ?
                                        component.metadata.price_per_month :
                                        `${PriceFormat.format(component.metadata.price_per_month)},-`
                                    }
                                </p>
                            </div>
                        </div>
                    );
                }
                break;
            case 'Verhuur':
                if (component.metadata?.rental_price) {
                    return (
                        <div className="col-12">
                            <div className="rental-price">
                                <p className="text--14 text--xl-16 mb-0">
                                    {trans('flow.rental.total_price')}
                                </p>
                                <p className="mb-1 text-right text-md-left text-base text--22 font-weight-extra-bold">
                                    {PriceFormat.format(component.metadata.rental_price)},-
                                </p>
                            </div>
                        </div>
                    );
                }
                break;
            case 'Kopen':
                if (component.metadata?.vehicle_price) {
                    return (
                        <div className="col-12">
                            <div className="vehicle-price">
                                <p className="text--14 text--xl-16 mb-0">
                                    Voertuigprijs
                                </p>
                                <p className="mb-1 text-right text-md-left text-base text--22 font-weight-extra-bold">
                                    {PriceFormat.format(component.metadata.vehicle_price)},-
                                </p>
                            </div>
                        </div>
                    );
                }
                break;
        }
        return null;
    };

    return (
        <div className="col-12">
            <div className={`conversion-flow__purchase-type-configurator conversion-flow__${selectedPurchaseType || 'default'}`}>
                <div className="row gutters-x-4 gutters-y-4">
                    <FlowRendererField
                        key={selectedPurchaseType || 'default'}
                        component={component}
                        fields={component?.fields}
                        path={`${path}.fields`}
                        id={`${id}.fields`}
                        {...passProps}
                    />
                    {renderPriceDisplay()}
                </div>
            </div>
        </div>
    );
}
